import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

const tabletd = {

	border: '1px solid black', borderCollapse: 'collapse', textAlign: 'center'
};

class PrintTimeTable extends Component {

	constructor(props) {
		super(props);
		this.state = {
			id: '',
			reportby: '',
			type: '',
			acyear: '',
			cls: '',
			classname: '',
			sectionname: '',
			section: '',
			_message: '',
			alertClass: '',
			posts: [],
			depart: [],
			secs: [],
			data: [],
			accyear: [],
			_redirect: false,
			modal: false,
			alsec: [],
			alldata: [],
			alltimedata: [],
			department: '',
			employee: '',
			empdata: [],
			teacher: [],
			empname: '',
			depname: '',
		}
		this.onRepChange = this.onRepChange.bind(this);
		this.onTypeChange = this.onTypeChange.bind(this);
		this.onYearChange = this.onYearChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onDepChange = this.onDepChange.bind(this);
		this.onEmpChange = this.onEmpChange.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.printClassDocument = this.printClassDocument.bind(this);
		this.printDocument3 = this.printDocument3.bind(this);
		this.printDocument2 = this.printDocument2.bind(this);
	}

	printClassDocument() {

		var content = document.getElementById("allclass");
		var pri = document.getElementById("print_frame1").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	printDocument() {

		var content = document.getElementById("showdata");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	printDocument3() {

		var content = document.getElementById("allstaff");
		var pri = document.getElementById("print_frame3").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	printDocument2() {

		var content = document.getElementById("staffdata");
		var pri = document.getElementById("print_frame2").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	onYearChange(e) {
		$("#clas").val('');
		$("#secs").val('');
		this.state.data = [];
		this.state.cls = '';
		this.state.section = '';
		this.state.acyear = e.target.value;
	}

	onClassChange(e) {
		$("#secs").val('');
		this.state.data = [];
		this.state.section = '';
		this.state.cls = e.target.value;
		this.state.classname = $("#clas").find(':selected').attr('data-cls');
	}

	onSecChange(e) {
		this.state.data = [];
		this.state.section = e.target.value;
		this.state.sectionname = $("#secs").find(':selected').attr('data-sec');
		this.gettimetab();
	}
	onTypeChange(e) {
		$("#clas").val('');
		$("#secs").val('');
		$("#dep").val('');
		$("#emp").val('');
		this.setState({ data: [], cls: '', section: '', type: e.target.value, department: '', employee: '', empdata: [] });
		if (e.target.value == 'all') {

			this.getalltimetable();
		}
	}

	onRepChange(e) {
		$("#clas").val('');
		$("#secs").val('');
		$("#dep").val('');
		$("#emp").val('');
		this.setState({ data: [], cls: '', section: '', reportby: e.target.value, department: '', employee: '', empdata: [] });
	}

	onDepChange(e) {

		this.state.department = e.target.value;
		this.state.depname = $("#dep").find(':selected').attr('data-dep');
	}

	onEmpChange(e) {

		this.state.employee = e.target.value;
		this.state.empname = $("#emp").find(':selected').attr('data-empname');
		this.getteatimetab();
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getclass();
		this.getdepartment();
		this.getacyear();
		this.getteacher();
	}

	getallsection() {

		var ac = this.state.acyear;
		GetData('section/getsecbyacyear/' + ac).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					alsec: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** get Teacher **/
	getteacher() {

		GetData('employee/getteacher').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					teacher: responseJson
				});
			}
		});
	}

	getdepartment() {

		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					depart: responseJson
				});
			}
		});
	}

	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getallsection();
			}
		});
	}

	getteatimetab() {

		GetData('timetable/gettimetablebyemp/' + this.state.acyear + '/' + this.state.employee).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					empdata: responseJson
				});
			}
		});
	}

	gettimetab() {

		GetData('timetable/gettimetable/' + this.state.acyear + '/' + this.state.cls + '/' + this.state.section).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	getalltimetable() {

		GetData('timetable/getalltimetable/' + this.state.acyear).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					alldata: responseJson
				});
			}
		});
	}

	getperiod() {
		var period = [];

		for (var i = 1; i < 9; i++) {

			period.push(<td style={tabletd}>{i}</td>);
		}

		return period;
	}

	getselect(dayid) {

		var btntd = [];

		for (var j = 1; j < 9; j++) {

			if (this.checkdata(dayid, j)) {

				btntd.push(<td style={tabletd}>{this.checkdata(dayid, j)}</td>);
			}
			else {

				btntd.push(<td style={tabletd}></td>);
			}
		}
		return (btntd);
	}

	checkdata(days, hr) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.data.length; ii++) {

			if (this.state.data[ii].day == days && this.state.data[ii].hour == hr) {

				boolstate = this.state.data[ii].subname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	gethours() {

		var day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

		var tabtd = [];

		for (var k = 1; k < 6; k++) {

			tabtd.push(<tr>
				<td style={tabletd}>{day[k - 1]}</td>
				{this.getselect(day[k - 1])}
			</tr>);
		}
		return tabtd;
	}

	gettothours(cls, sec) {

		var day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

		var tabtd = [];

		for (var k = 1; k < 6; k++) {

			tabtd.push(<tr style={tabletd}>
				<td style={tabletd}>{day[k - 1]}</td>
				{this.getselectall(day[k - 1], cls, sec)}
			</tr>);
		}
		return tabtd;
	}

	getselectall(dayid, cls, sec) {

		var btntd = [];

		for (var j = 1; j < 9; j++) {

			if (this.checallkdata(dayid, j, cls, sec)) {

				btntd.push(<td style={tabletd}>{this.checallkdata(dayid, j, cls, sec)}</td>);
			}
			else {

				btntd.push(<td style={tabletd}></td>);
			}
		}
		return (btntd);
	}

	checallkdata(days, hr, cls, sec) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.alldata.length; ii++) {

			if (this.state.alldata[ii].day == days && this.state.alldata[ii].hour == hr && this.state.alldata[ii].class == cls && this.state.alldata[ii].section == sec) {

				boolstate = this.state.alldata[ii].subname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	gettimetable() {

		var dat = [];

		for (var k = 0; k < this.state.posts.length; k++) {

			for (var j = 0; j < this.state.alsec.length; j++) {

				if (this.state.alsec[j].clas == this.state.posts[k].id) {

					dat.push(
						<Col md="12">
							<b>{this.state.posts[k].class} - {this.state.alsec[j].secs}</b>
							<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%">
								<thead>
									<tr>
										<td style={tabletd} width="130px">Days</td>
										{this.getperiod()}
									</tr>
								</thead>
								<tbody>
									{this.gettothours(this.state.posts[k].id, this.state.alsec[j].section)}
								</tbody>
							</Table>
						</Col>
					);
				}
			}
		}
		return dat;
	}

	getstaffhours() {

		var day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

		var tabtd = [];

		for (var k = 1; k < 6; k++) {

			tabtd.push(<tr style={tabletd}>
				<td style={tabletd}>{day[k - 1]}</td>
				{this.getselectstaff(day[k - 1])}
			</tr>);
		}
		return tabtd;
	}

	getselectstaff(dayid) {

		var btntd = [];

		for (var j = 1; j < 9; j++) {

			if (this.checksub(dayid, j)) {

				btntd.push(<td style={tabletd} width="150px">{this.checksub(dayid, j)}<br />{this.checkclass(dayid, j)}</td>);
			}
			else {

				btntd.push(<td style={tabletd} width="150px"></td>);
			}
		}
		return (btntd);
	}

	checksub(days, hr) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.empdata.length; ii++) {

			if (this.state.empdata[ii].day == days && this.state.empdata[ii].hour == hr) {

				boolstate = this.state.empdata[ii].subname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	checkclass(days, hr) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.empdata.length; ii++) {

			if (this.state.empdata[ii].day == days && this.state.empdata[ii].hour == hr) {

				boolstate = this.state.empdata[ii].classname + ' ' + this.state.empdata[ii].sectionname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	getteachertimetable() {

		var dat = [];

		for (var i = 0; i < this.state.teacher.length; i++) {

			dat.push(
				<Col md="12">
					<b>Time Table For : {this.state.teacher[i].empname}</b>
					<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%">
						<thead>
							<tr>
								<td style={tabletd} width="130px">Days</td>
								{this.getperiod()}
							</tr>
						</thead>
						<tbody>
							{this.getstaffallhours(this.state.teacher[i].id)}
						</tbody>
					</Table>
				</Col>
			);
		}

		return dat;
	}

	getstaffallhours(tea) {

		var day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

		var tabtd = [];

		for (var k = 1; k < 6; k++) {

			tabtd.push(<tr style={tabletd}>
				<td style={tabletd}>{day[k - 1]}</td>
				{this.getall(day[k - 1], tea)}
			</tr>);
		}
		return tabtd;
	}

	getall(dayid, tea) {

		var btntd = [];

		for (var j = 1; j < 9; j++) {

			if (this.checkallsub(dayid, j, tea)) {

				btntd.push(<td style={tabletd} width="150px">{this.checkallsub(dayid, j, tea)}<br />{this.checkallclass(dayid, j, tea)}</td>);
			}
			else {

				btntd.push(<td style={tabletd} width="150px"></td>);
			}
		}
		return (btntd);
	}

	checkallsub(days, hr, tea) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.alldata.length; ii++) {

			if (this.state.alldata[ii].day == days && this.state.alldata[ii].hour == hr && this.state.alldata[ii].teacher == tea) {

				boolstate = this.state.alldata[ii].subname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	checkallclass(days, hr, tea) {

		var boolstate = false;
		for (var ii = 0; ii < this.state.alldata.length; ii++) {

			if (this.state.alldata[ii].day == days && this.state.alldata[ii].hour == hr && this.state.alldata[ii].teacher == tea) {

				boolstate = this.state.alldata[ii].classname + ' ' + this.state.alldata[ii].sectionname;
				break;
			}
			else {
				boolstate = false;
			}

		}
		return boolstate;
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/academic/editteacherallocate/' + this.state.idd} />);

		}

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '') {

			$("#showdata").show();
		}
		else {

			$("#showdata").hide();
		}

		if (this.state.department != '' && this.state.employee != '') {

			$("#staffdata").show();
		}
		else {

			$("#staffdata").hide();
		}

		var items = this.state.posts;
		var dep = this.state.depart;
		var acyear = this.state.accyear;

		/** get Section By Class **/
		$("#clas").change(function () {
			var fr = $(this).val();
			var ar = $("#year").val();
			$.get(GLOBAL.BASE_URL + 'section/getsecbyclass/' + ar + '/' + fr, function (o) {
				$("#secs").html('');
				$('#secs')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Section- '));
				$.each(o, function (key, value) {
					$('#secs')
						.append($("<option></option>")
							.attr("value", value.id)
							.attr("data-sec", value.secs)
							.text(value.secs));

				});

			}, 'json');

		});

		/** get Employee By Department **/
		$("#dep").change(function () {
			var fr = $(this).val();
			$.get(GLOBAL.BASE_URL + 'employee/getempbydept/' + fr, function (o) {
				$("#emp").html('');
				$('#emp')
					.append($("<option></option>")
						.attr("value", '')
						.text(' -Select Employee- '));
				$.each(o, function (key, value) {
					$('#emp')
						.append($("<option></option>")
							.attr("value", value.id)
							.attr("data-empname", value.empname)
							.text(value.empname));

				});

			}, 'json');

		});

		this.rep = [
			{ value: '', name: 'Select' },
			{ value: 'class', name: 'Class Wise' },
			{ value: 'staff', name: 'Staff Wise' },
			{ value: 'both', name: 'Both' }
		];

		this.type = [
			{ value: '', name: 'Select' },
			{ value: 'all', name: 'All' },
			{ value: 'single', name: 'Single' }
		];

		if (this.state.type == 'single') {

			if (this.state.reportby == 'class') {

				$(".class").show();
				$(".staff").hide();
				$("#allclass").hide();
				$(".allclass").hide();
				$(".allstaff").hide();
				$("#allstaff").hide();
			}
			else if (this.state.reportby == 'staff') {

				$(".staff").show();
				$(".class").hide();
				$("#allclass").hide();
				$(".allclass").hide();
				$("#allstaff").hide();
				$(".allstaff").hide();
			}
			else {

				$(".staff").hide();
				$(".class").hide();
				$("#allclass").hide();
				$(".allclass").hide();
				$("#allstaff").hide();
				$(".allstaff").hide();
			}
		}
		else if (this.state.type == 'all') {

			if (this.state.reportby == 'class') {
				$(".staff").hide();
				$(".class").hide();
				$("#showdata").hide();
				$("#allclass").show();
				$(".allclass").show();
				$("#staffdata").hide();
				$("#allstaff").hide();
				$(".allstaff").hide();
			}
			else if (this.state.reportby == 'staff') {

				$(".staff").hide();
				$(".class").hide();
				$("#showdata").hide();
				$("#allclass").hide();
				$(".allclass").hide();
				$("#staffdata").hide();
				$("#allstaff").show();
				$(".allstaff").show();
			}
			else {

				$(".staff").hide();
				$(".class").hide();
				$("#showdata").hide();
				$("#allclass").hide();
				$(".allclass").hide();
				$("#staffdata").hide();
				$("#allstaff").hide();
				$(".allstaff").hide();
			}
		}
		else {

			$(".staff").hide();
			$(".class").hide();
			$("#showdata").hide();
			$("#allclass").hide();
			$(".allclass").hide();
			$("#staffdata").hide();
			$("#allstaff").hide();
			$(".allstaff").hide();
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<form action="" method="post" role="form" id="userform" encType="multipart/form-data" onSubmit={this.onSubmit} >
									<CardHeader>
										<strong>Print Time Table</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<select name="ctype" onChange={this.onRepChange} required>
											{this.rep.map((e, key) => {
												return <option key={key} value={e.value}>{e.name}</option>;
											})}
										</select>&nbsp;&nbsp;&nbsp;
							<select name="ctype" onChange={this.onTypeChange} required>
											{this.type.map((e, key) => {
												return <option key={key} value={e.value}>{e.name}</option>;
											})}
										</select>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="2" className="class">
												<FormGroup>
													<Label>Academic Year</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="class">
												<FormGroup>
													<select name="acyear" onChange={this.onYearChange} className="form-control" required id="year">
														<option value="">Select</option>
														{
															acyear.map(function (item) {
																return <option value={item.id}>{item.value}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="1" className="class">
												<FormGroup>
													<Label>Class</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="class">
												<FormGroup>
													<select name="cls" onChange={this.onClassChange} id="clas" className="form-control" required>
														<option value="">Select Class</option>
														{
															items.map(function (item) {
																return <option value={item.id} data-cls={item.class}>{item.class}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="1" className="class">
												<FormGroup>
													<Label>Section</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="class">
												<FormGroup>
													<select name="section" onChange={this.onSecChange} id="secs" className="form-control" required>

													</select>
												</FormGroup>
											</Col>
											<Col md="2" className="class">
												<FormGroup>
													<Button style={{ float: 'right' }} size="sm" color="warning" onClick={this.printDocument}>Print</Button>
												</FormGroup>
											</Col>
											<Col md="12" className="allclass">
												<FormGroup>
													<Button style={{ float: 'right' }} size="sm" color="warning" onClick={this.printClassDocument}>Print</Button>
												</FormGroup>
											</Col>
											<Col md="1" className="staff">
												<FormGroup>
													<Label>Department</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="staff">
												<FormGroup>
													<select name="dept" onChange={this.onDepChange} id="dep" className="form-control" required>
														<option value="">Select Department</option>
														<option value="all">All</option>
														{
															dep.map(function (item) {
																return <option value={item.id} data-dep={item.department}>{item.department}</option>;
															})
														}
													</select>
												</FormGroup>
											</Col>
											<Col md="1" className="staff">
												<FormGroup>
													<Label>Employee</Label>
												</FormGroup>
											</Col>
											<Col md="2" className="staff">
												<FormGroup>
													<select name="employee" onChange={this.onEmpChange} id="emp" className="form-control" required>

													</select>
												</FormGroup>
											</Col>
											<Col md="6" className="staff">
												<FormGroup>
													<Button style={{ float: 'right' }} size="sm" color="warning" onClick={this.printDocument2}>Print</Button>
												</FormGroup>
											</Col>
											<Col md="12" className="allstaff">
												<FormGroup>
													<Button style={{ float: 'right' }} size="sm" color="warning" onClick={this.printDocument3}>Print</Button>
												</FormGroup>
											</Col>
										</Row>
										<Row id="showdata">
											<Col md="10 offset-1">
												<table>
													<tbody>
														<tr>
															<td rowSpan="4" width="170" align="right" style={{ paddingLeft: '90px', paddingRight: '10px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
														</tr>
														<tr>
															<td align="center" className="ctext">{GLOBAL.Sclful_NAME}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Addr}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Dist}</td>
														</tr>
													</tbody>
												</table>
												<hr className="line-margin"></hr>
											</Col>
											<Col md="12">
												<FormGroup>
													<b>Time Table For : {this.state.classname} - {this.state.sectionname}</b>
												</FormGroup>
											</Col>
											<Col md="12">
												<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%">
													<thead>
														<tr>
															<td style={tabletd} width="130px">Days</td>
															{this.getperiod()}
														</tr>
													</thead>
													<tbody>
														{this.gethours()}
													</tbody>
												</Table>
											</Col>
											<iframe name="print_frame" id="print_frame" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
										</Row>
										<Row id="allclass">
											<Col md="10 offset-1">
												<table>
													<tbody>
														<tr>
															<td rowSpan="4" width="170" align="right" style={{ paddingLeft: '90px', paddingRight: '10px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
														</tr>
														<tr>
															<td align="center" className="ctext">{GLOBAL.Sclful_NAME}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Addr}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Dist}</td>
														</tr>
													</tbody>
												</table>
												<hr className="line-margin"></hr>
											</Col>
											{this.gettimetable()}
											<iframe name="print_frame" id="print_frame1" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
										</Row>
										<Row id="staffdata">
											<Col md="10 offset-1">
												<table>
													<tbody>
														<tr>
															<td rowSpan="4" width="170" align="right" style={{ paddingLeft: '90px', paddingRight: '10px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
														</tr>
														<tr>
															<td align="center" className="ctext">{GLOBAL.Sclful_NAME}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Addr}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Dist}</td>
														</tr>
													</tbody>
												</table>
												<hr className="line-margin"></hr>
											</Col>
											<Col md="12">
												<FormGroup>
													<b>Time Table For : {this.state.empname} ({this.state.depname} Department)</b>
												</FormGroup>
											</Col>
											<Col md="12">
												<Table responsive style={{ border: '1px solid black', borderCollapse: 'collapse' }} width="100%">
													<thead>
														<tr>
															<td style={tabletd} width="130px">Days</td>
															{this.getperiod()}
														</tr>
													</thead>
													<tbody>
														{this.getstaffhours()}
													</tbody>
												</Table>
											</Col>
											<iframe name="print_frame" id="print_frame2" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
										</Row>
										<Row id="allstaff">
											<Col md="10 offset-1">
												<table>
													<tbody>
														<tr>
															<td rowSpan="4" width="170" align="right" style={{ paddingLeft: '90px', paddingRight: '10px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
														</tr>
														<tr>
															<td align="center" className="ctext">{GLOBAL.Sclful_NAME}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Addr}</td>
														</tr>
														<tr>
															<td align="center" className="caddrtext">{GLOBAL.Scl_Dist}</td>
														</tr>
													</tbody>
												</table>
												<hr className="line-margin"></hr>
											</Col>
											{this.getteachertimetable()}
											<iframe name="print_frame" id="print_frame3" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
										</Row>
									</CardBody>
								</form>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default PrintTimeTable;


// WEBPACK FOOTER //
// ./src/timetable/PrintTimeTable/PrintTimeTable.js